import { useUserStore } from '@/store/user';
import { EditButton } from '../components/EditButton';
import { useState } from 'react';
import { EditField } from '../components/EditField';
import { useMutation } from '@tanstack/react-query';
import { SubmitUpdateProfile, updateProfile } from '../api/updateProfile';
import i18n from '@/localisation/i18n';

export const FullName = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { name, updatePsychologist } = useUserStore();

  const [updatedName, setUpdatedName] = useState(name);

  const { mutate } = useMutation({
    mutationFn: (data: SubmitUpdateProfile) => updateProfile(data),
    onSuccess: () => {
      updatePsychologist({ name: updatedName });
      setIsEditing(false);
    },
  });

  return (
    <>
      <div className="my-3 flex w-full justify-between md:my-5">
        <div>
          <div className="text-base text-additional">
            {i18n.t('full.name')}*
          </div>
          <div className="text-xs text-additional">{i18n.t('will.shown')}</div>
          <EditField
            isEditing={isEditing}
            name={name}
            updatedName={updatedName}
            setUpdatedName={setUpdatedName}
          />
        </div>
        <EditButton
          isEditing={isEditing}
          isDisabled={!updatedName && isEditing}
          onClick={() => {
            if (isEditing) {
              mutate({ name: updatedName });
              return;
            }

            setUpdatedName(name);
            setIsEditing(!isEditing);
          }}
        />
      </div>
      <div className="divider"></div>
    </>
  );
};
